"use server";

import {
  getRegisterDetails,
  RegisterDetailsResponse,
} from "../services/registerDetailsService";
import { extractDomain } from "../utils/domain";

export async function getRegisterDetailsAction(
  registrationId: string
): Promise<RegisterDetailsResponse | null> {
  try {
    const domain = await extractDomain();
    const data = await getRegisterDetails(registrationId, domain);
    return data;
  } catch (error) {
    console.error("[getRegisterDetailsAction] Error:", error);
    return null;
  }
}
